import { EmptyState } from '@gorila-shared-ui/components';
import { StyledHead, StyledHeadCell, StyledTable } from 'baseui/table';
import AutoSizer from 'react-virtualized-auto-sizer';
import { VariableSizeList as List } from 'react-window';
import { SMALL_LIST_ITEM_HEIGHT } from '../../../constants/app';
import { DOOR_EVENTS_COLUMNS, EXTENDED_DOOR_EVENTS_COLUMNS } from '../../../constants/reports';
import { useStyles } from '../../../hooks/useStyles';
import { HistoricDoorState } from '../../../types/currentState';
import DoorStateReportRow from './DoorStateReportRow';
import { useEffect } from 'react';
import { useResetRecoilState } from 'recoil';
import { activeDoorState, selectedReportRowState } from '../../../storage/reports';

type Props = {
  states?: HistoricDoorState[];
  extended?: boolean;
};

function DoorStateReportTable({ states, extended = false }: Readonly<Props>) {
  const { styles } = useStyles();
  const resetActiveDoorState = useResetRecoilState(activeDoorState);
  const resetSelectedReportRowState = useResetRecoilState(selectedReportRowState);

  useEffect(() => {
      return () => {
        resetActiveDoorState();
        resetSelectedReportRowState();
      };
    }, []);

  if (!states?.length) {
    return <EmptyState title="No cuenta con registros de apertura o cierre." />;
  }

  return (
    <StyledTable>
      <StyledHead $width={extended ? '800px' : undefined}>
        {(extended ? EXTENDED_DOOR_EVENTS_COLUMNS : DOOR_EVENTS_COLUMNS).map((column, index) => (
          <StyledHeadCell
            key={index}
            style={{
              flex: column.size,
              maxWidth: column.maxWidth ? `${column.maxWidth}px` : undefined,
              justifyContent: column.centered ? 'center' : undefined,
              ...styles.smallTableCellHeader,
            }}
          >
            {column.title}
          </StyledHeadCell>
        ))}
      </StyledHead>
      <div style={{ flex: 1, minHeight: '250px', width: extended ? '800px' : undefined }}>
        <AutoSizer>
          {({ width, height }) => (
            <List
              height={height}
              itemCount={states.length}
              itemSize={() => SMALL_LIST_ITEM_HEIGHT}
              width={width}
              itemData={{ states, extended }}
            >
              {DoorStateReportRow}
            </List>
          )}
        </AutoSizer>
      </div>
    </StyledTable>
  );
}

export default DoorStateReportTable;
